import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'clientListCheckbox',
        'customTagsContainer',
        'customTypeInput',
    ];

    static values = {
        closeBtnUrl: String,
        placeholder: String,
    };

    openModal() {
        $(this.element).modal({
            backdrop: 'static',
            focus: false,
            show: true,
        });
    }

    addCustomClient() {
        const closeBtnUrl = this.closeBtnUrlValue || '/build/images/close-btn.svg';
        const placeholder = this.placeholderValue || '';

        const tag = document.createElement('div');
        tag.className = 'rounded-pill bg-primary-10percent d-inline-flex align-items-center py-0 px-0 fs-12 me-1 overflow-hidden company-list-item';
        tag.innerHTML = `
            <input
                type="text"
                class="form-control"
                placeholder="${placeholder}"
                data-profile--client-list-edit-modal-target="customTypeInput"
                data-controller="autoresize-input"
                style="min-width: 100px;"
            >
            <button
                type="button"
                class="profile-pill-close"
                data-action="profile--client-list-edit-modal#removeCustomTag"
            >
                <img src="${closeBtnUrl}" width="12" height="12" alt="" aria-hidden="true">
            </button>
        `;
        this.customTagsContainerTarget.appendChild(tag);

        tag.querySelector('input').focus();
    }

    removeCustomTag(event) {
        event.currentTarget.closest('.company-list-item').remove();
    }

    save() {
        const clientList = this.clientListCheckboxTargets
            .filter((cb) => cb.checked)
            .map((cb) => cb.value);

        const clientTypes = this.customTypeInputTargets
            .map((input) => input.value.trim())
            .filter((val) => val.length > 0);

        showPreloader();

        $.ajax({
            method: 'POST',
            url: routes['app_profile_clientlistfieldupdate'],
            data: {
                client_list: clientList,
                client_types: JSON.stringify(clientTypes),
            },
            success: (response) => {
                if (response.status) {
                    $(this.element).modal('hide');

                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'profile_client_list_modification',
                            'label': '',
                        },
                    });

                    window.location.reload();
                } else {
                    hidePreloader();
                    addAlert('danger', response.message ?? translations['profile.An unknown error occurred.']);
                }
            },
            error: function(error) {
                hidePreloader();
                const json = error.responseJSON;
                addAlert('danger', json?.message ?? translations['profile.An unknown error occurred.']);
            },
        });
    }
}
